import { useQuery } from '@tanstack/react-query';
import { CalendarioEventos } from '@xiltrion/ui/bloques/calendario-eventos';
import { usePedir } from '@xiltrion/ui/bloques/pedir';
import { apiGet } from '@/api/client';
import { useCreateTask, useUpdateTask } from '@/api/hooks';
import type { ViewProps } from '@/app/extension-points';
import { applyFilters } from '../tasks/view-logic';

/** Vista Calendario: las tareas en su fecha (vencimiento o inicio); arrastrar cambia la fecha. Sombrea los festivos del calendario del tenant. */
export function CalendarView({ project, tasks, view, onOpenTask }: ViewProps) {
  const field = view?.config.calendar?.dateField ?? 'dueDate';
  const { data: cal } = useQuery({ queryKey: ['calendar'], queryFn: () => apiGet<{ holidays: string[] }>('/admin/calendar'), staleTime: 3600_000 });
  const update = useUpdateTask();
  const create = useCreateTask();
  const visible = applyFilters(tasks, view?.config).filter((t) => t[field]);
  const canEdit = project ? project.capabilities.editTasks : true;
  const { pedir, dialogo } = usePedir();
  return (
    <div className="p-4">
      <CalendarioEventos
        eventos={visible.map((t) => ({ id: t.id, titulo: t.title, fecha: t[field]!, completado: !!t.completedAt, color: t.priority === 'URGENT' ? 2 : t.priority === 'HIGH' ? 7 : 1 }))}
        festivos={cal?.holidays}
        modo={view?.config.calendar?.mode === 'week' ? 'semana' : 'mes'}
        onAbrirEvento={onOpenTask}
        onMoverEvento={canEdit ? (id, fecha) => update.mutate({ id, patch: { [field]: fecha } }) : undefined}
        onCrear={project && canEdit ? async (fecha) => { const title = await pedir({ titulo: 'Tarea nueva', etiqueta: 'Título', textoConfirmar: 'Crear' }); if (title) create.mutate({ projectId: project.id, title, [field]: fecha } as never); } : undefined}
      />
      {dialogo}
    </div>
  );
}
